// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"958453ba","234":"a06c79e9","353":"fd4eea9c"}[chunkId] + ".js";
};